import axios from './axios';

export default {
  list: () => axios.get('/type_connectivites'),
};
